import { type ProjectPartnerWithAction_userProfile$key } from '#app/__generated__/relay/ProjectPartnerWithAction_userProfile.graphql.js';
import { Avatar } from '#app/components/Avatars/Avatar/Avatar.js';
import { Button } from '#app/components/Buttons/Button.js';
import { Link } from '#app/components/Link/index.js';
import { Text } from '#app/components/Primitives/Text.js';
import { useAnalytics } from '#app/hooks/useAnalytics.js';
import { useOnElementViewed } from '#app/hooks/useOnElementViewed.js';
import { graphql, useFragment } from '@contra/relay';
import { styled } from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  align-items: center;
  margin-left: auto;
  margin-right: auto;

  > * + * {
    margin-top: 24px;
  }
`;

type ProjectPartnerWithActionProps = {
  readonly profileRef: ProjectPartnerWithAction_userProfile$key;
};

export const ProjectPartnerWithAction = ({
  profileRef,
}: ProjectPartnerWithActionProps) => {
  const { analyticsId, avatarImage, displayUsername, firstName } = useFragment(
    graphql`
      fragment ProjectPartnerWithAction_userProfile on UserProfile {
        id
        firstName
        analyticsId
        displayUsername
        avatarImage {
          uid
          url
        }
      }
    `,
    profileRef,
  );

  const { track } = useAnalytics();

  const onViewedRef = useOnElementViewed<HTMLAnchorElement>(() =>
    track('button', {
      action: 'viewed',
      button_name: 'identity_project_page_view_services',
      owner_id: analyticsId,
      section: 'partner_with',
    }),
  );

  return (
    <Container>
      <Avatar
        avatarImage={avatarImage}
        size="lg"
      />
      <Text
        as="h5"
        color="brandBlack"
        textStyle="fifthLevelHeadline"
      >
        Partner With {firstName}
      </Text>
      <Button
        as={Link}
        onClick={() =>
          track('button', {
            action: 'tapped',
            button_name: 'identity_project_page_view_services',
            owner_id: analyticsId,
            section: 'partner_with',
          })
        }
        ref={onViewedRef}
        to={`/${displayUsername}/services`}
        variant="V2Primary"
      >
        View Services
      </Button>
    </Container>
  );
};
